export var ResourceType;
(function (ResourceType) {
    ResourceType["WOOD"] = "WOOD";
    ResourceType["WINE"] = "WINE";
    ResourceType["MARBLE"] = "MARBLE";
    ResourceType["CRYSTAL"] = "CRYSTAL";
    ResourceType["SULFUR"] = "SULFUR";
})(ResourceType || (ResourceType = {}));
export var LuxuryResource;
(function (LuxuryResource) {
    LuxuryResource["WINE"] = "WINE";
    LuxuryResource["MARBLE"] = "MARBLE";
    LuxuryResource["CRYSTAL"] = "CRYSTAL";
    LuxuryResource["SULFUR"] = "SULFUR";
})(LuxuryResource || (LuxuryResource = {}));
//# sourceMappingURL=resources.js.map